import React from 'react';
import { FormAction } from './form-reducer';

export interface FormInterface {
  state: Record<string, any>;
  dispatch?(action: FormAction): void;
}

export const FormContext = React.createContext<FormInterface | null>(null);
